import styled, { Interpolation } from 'styled-components';
type props = {
  styles?: Interpolation<React.CSSProperties>
	fullScreenEnabled?:boolean;
	isParentSQ?: boolean;
}
export const FlexDivRow = styled.div<props>`
	display: flex;
	flex-direction: row;
	// margin-top: .2em;
	margin-bottom: 0;
	align-items:center;
	gap:.45rem;
	padding-right: 2px;
	${({ styles }) => styles}
	// @media (max-width: 500px){
	// 	margin-bottom: 1rem;
	// }

		// background:#fff;
		// padding: .25rem .85rem;
		// border-radius:25px;
	
	label{
		font-family: Inter;
    font-weight: 600;
    color: var(--subHeadingColor);
    padding-right: 0px;
    line-height: normal;
    font-size: 0.875rem;
		position: relative;
		top: 0px;
	}
`;